const actionTypes = {
    SET_PREFERRED_CURRENCY: 'CURRENCY/SET_PREFERRED_CURRENCY',
    OPEN_MULTI_CURRENCY_DESKTOP: 'CURRENCY/OPEN_MULTI_CURRENCY_DESKTOP',
    CLOSE_MULTI_CURRENCY_DESKTOP: 'CURRENCY/CLOSE_MULTI_CURRENCY_DESKTOP',
    OPEN_MULTI_CURRENCY_MOBILE: 'CURRENCY/OPEN_MULTI_CURRENCY_MOBILE',
    CLOSE_MULTI_CURRENCY_MOBILE: 'CURRENCY/CLOSE_MULTI_CURRENCY_MOBILE',
    SET_CURRENCY_SELECTED_BY_USER: 'CURRENCY/SET_CURRENCY_SELECTED_BY_USER',
    SET_CURRENCY_IF_NOT_CHOSEN: 'CURRENCY/SET_CURRENCY_IF_NOT_CHOSEN'
};

const setPreferredCurrency = currencyCode => ({
    type: actionTypes.SET_PREFERRED_CURRENCY,
    currencyCode
});

const setCurrencyIfNotChosen = currencyCode => ({
    type: actionTypes.SET_CURRENCY_IF_NOT_CHOSEN,
    currencyCode
});

const openMultiCurrencyDesktop = id => ({
    type: actionTypes.OPEN_MULTI_CURRENCY_DESKTOP,
    id
});

const closeMultiCurrencyDesktop = () => ({
    type: actionTypes.CLOSE_MULTI_CURRENCY_DESKTOP
});

const openMultiCurrencyMobile = () => ({
    type: actionTypes.OPEN_MULTI_CURRENCY_MOBILE
});

const closeMultiCurrencyMobile = () => ({
    type: actionTypes.CLOSE_MULTI_CURRENCY_MOBILE
});

const setCurrencySelectedByUser = () => ({
    type: actionTypes.SET_CURRENCY_SELECTED_BY_USER
});

export default {
    setPreferredCurrency,
    actionTypes,
    openMultiCurrencyDesktop,
    closeMultiCurrencyDesktop,
    openMultiCurrencyMobile,
    closeMultiCurrencyMobile,
    setCurrencySelectedByUser,
    setCurrencyIfNotChosen
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/multi-currency.js